/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import React, {Fragment, useEffect, useState} from 'react';

import { getHistoricalTransactionsV2 } from 'services/Rest';
import {
  MUTUAL_FUND
} from 'services/Products';
import LocalBeaconTable from 'components/shared/Table/BeaconTable';
import './TransactionHistoryFiltersV2.scss';
import {buildTransactionHistoryTable} from "./TransactionPageUtils";
import {isEmpty} from "lodash";
import TransactionHistoryFiltersV2 from "./TransactionHistoryFiltersV2";
const MAX_DAYS = 1095;
const TransactionHistoryTable = ({
  transactionHistoryTableData,
  filterOptions = []
}) => {
  const [transactionHistoryTable, setTransactionHistoryTable] = useState(null);

  // Make the initial service call to get transaction history information
  useEffect(() => {
    getHistoricalTransactionsV2(MAX_DAYS);
  }, []);

  // Rebuild the table if the data or filters change
  useEffect(() => {
    if (!isEmpty(transactionHistoryTableData)) {
      setTransactionHistoryTable(
        buildTransactionHistoryTable(
          transactionHistoryTableData?.transactionHistoryData,
          transactionHistoryTableData?.transactionHistoryAccounts,
          transactionHistoryTableData?.transactionsExpandedAccordion,
          filterOptions
        )
      )
    }
  }, [filterOptions, transactionHistoryTableData]);

  // TODO: Custom loading state
  if (!transactionHistoryTable) {
    return null;
  }
  return (
    <Fragment>
      <div className="transactions-history-table-container-v2">
        <div>
          {transactionHistoryTable.rows?.length > 0 && (
            <TransactionHistoryFiltersV2 filterOptions={filterOptions} />
          )}
        </div>
        {transactionHistoryTable.rows?.length > 0 ? (
          <LocalBeaconTable
            classType={'transactions-history-table-v2'}
            idName={'transactions-history-beacon-table-v2'}
            variant={'fixed'}
            headers={transactionHistoryTable.headers}
            rowsArray={transactionHistoryTable.rows}
          />
        ) : (
          <div className="zero-state-message-v2">
            <span className="cost-basis-no-data-available b-typography-sans-serif--headline--50">
              There is no transaction history for the filter criteria selected.
            </span>
          </div>
        )}
      </div>
    </Fragment>
  );
};

TransactionHistoryTable.defaultProps = {
  includeTransactionHistory: false,
  productType: MUTUAL_FUND,
  viewMoreLink: '',
  hasCollegeSavingsOnly: false
};

export default TransactionHistoryTable;
